/* @generated */
import * as React from "react";
import { mapResponsiveValue } from "../config/atoms.css.esm.js";
import { splitItemStyle } from "./split.css.esm.js";
import cx from "classnames";
import { useFlexGap } from "./context.esm.js";
/* empty css                 */import { Box } from "../box/box.esm.js";
const growMapping = {
  hug: 0,
  fill: 1
};
const shrinkMapping = {
  hug: 1,
  fill: 0
};
const Item = ({
  children,
  width,
  style,
  marginRight,
  marginBottom,
  className,
  willCollapse,
  ...rest
}) => {
  const isFlexGap = useFlexGap();
  const _className = cx(className, {
    // This turns off the negative margins being applied directly to these elements
    // and instead uses flexbox gap being set from the parent.
    [splitItemStyle]: !isFlexGap
  });
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      tagName: "span",
      flexGrow: width ? mapResponsiveValue(width, (val) => growMapping[val]) : void 0,
      flexShrink: width ? mapResponsiveValue(width, (val) => shrinkMapping[val]) : void 0,
      flexBasis: width ? mapResponsiveValue(width, (val) => val === "fill" ? 0 : void 0) : void 0,
      className: _className,
      style,
      marginRight,
      marginBottom,
      minWidth: willCollapse ? "0" : void 0,
      ...rest
    },
    children
  );
};
export {
  Item
};
